import React, { useState, useEffect } from 'react';
import DeleteWarningForm from './deletewarning.js';
import "../css/eventsList.css";
import CommentCard from "./commentCard.js";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function SingleEventForm({event_data, onClose}) {

    const [isWarningVisible, setIsWarningVisible] = useState("");
    const [isCommentTabVisible, setIsCommentTabVisible] = useState("");
    const [comments, setComments] = useState("");

    const event = event_data[0];

    const {language} = useLanguage();

    const translations = {
      en: {
          noLocationsAvailable: "No locations available",
          close: "Close",
          locations: "Locations: ",
          checkIns: "Check Ins: ",
          deleteEvent: "Delete Event",
          numberOfLikes: "Number of likes: ",
          startTime: "Start Time: ",
          endTime: "End Time: ",
          startDate: "Start Date: ",
          endDate: "End Date: ",
          postcode: "Postcode: ",
          proficencyLevel: "Proficency Level: ",
          eventType: "Event Type: ",
          hostName: "Host Name: ",
          close: "Close",
          viewComments: "View Comments",
          hideResponses: "Hide Responses",
          noComments: "This event has no comments yet, write the first!",
          showingAllComments: "Showing all comments: ",
      },

      gd: {
          noLocationsAvailable: "Chan eil àiteachan rim faotainn",
          close: "Dùin",
          locations: "Àiteachan: ",
          checkIns: "Clàraidhean: ",
          deleteEvent: "Dubh às an tachartas",
          numberOfLikes: "An àireamh de rudan a tha dèidheil air: ",
          startTime: "Àm tòiseachaidh: ",
          endTime: "Àm crìochnachaidh: ",
          startDate: "Ceann-latha tòiseachaidh: ",
          endDate: "Ceann-latha crìochnachaidh: ",
          postcode: "Còd-puist: ",
          proficencyLevel: "Ìre Comais: ",
          eventType: "Seòrsa Tachartais: ",
          hostName: "Air Aoigheachd bho: ",
          close: "Dùin",
          viewComments: "Thoir sùil air na h-Abairtean",
          hideResponses: "Falaich na Freagairtean",
          noComments: "Chan eil beachdan ann mun tachartas seo fhathast, sgrìobh a' chiad fhear!",
          showingAllComments: "Taisbeanadh nan abairtean uile: ",

      },
  };

    console.log("title: ", event.title);

    const handleDeleteEventClick = () => {
        setIsWarningVisible(true);
      };

    const handleCancel = () => {
        setIsWarningVisible(false);
      };

    const handleConfirmDelete = async (id) => {

    console.log("In handle confirm delete");
        
    const response = await fetch(`${BASE_URL}/api/delete_event/`, {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({ event_id:id }),
    });
    
    if (response.ok) {
          
    console.log(id, "has now been deleted");
    setIsWarningVisible(false);
    onClose();
    } 
    };

    const fetchComments = async () => {

      try{
          const response = await fetch(
          `${BASE_URL}/api/comments/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },

            body: JSON.stringify({ 
              event_id: event.id,
            }),
          });

          const data = await response.json();
          setComments(data);

          setIsCommentTabVisible(true);

      } catch (error) {
          console.error('Error fetching comments:', error);
      }

  };

    
    
    return(
        <div className="event-card">
    
          <img className = "event-image" src = {event.picture} alt = "event image" />
          <h4 className = "event-title">{event.title} </h4>
          <h5 className = "event-description">{event.description}</h5>
          <p className = "event-check-ins">{translations[language].checkIns} {event.check_ins}</p>
          <p className = "event-likes">{translations[language].numberOfLikes} {event.likes}</p>
          <p className = "event-start-time">{translations[language].startTime} {event.start_time} </p>
          <p className = "event-end-time">{translations[language].endTime} {event.end_time} </p>
          <p className = "event-start-date">{translations[language].startDate} {event.start_date}</p>
          <p className = "event-end-date">{translations[language].endDate} {event.end_date}</p>
          <p className = "event-postcode">{translations[language].postcode} {event.postcode}</p>
          <p className = "proficiency">{translations[language].proficencyLevel} {event.proficency}</p>
          <p className = "event-type">{translations[language].eventType} {event.type}</p>
          <p className="event-host">{translations[language].hostName} {event.host_username} </p>

          <button onClick={() => handleDeleteEventClick(event.id)}> {translations[language].deleteEvent}</button>

          <button onClick={onClose}>{translations[language].close}</button>

          {isWarningVisible && (
            <div>
            <DeleteWarningForm
                deleteInfo={event.id}
                onCancel={handleCancel}
                onConfirm={() => handleConfirmDelete(event.id)}
            />
            </div>
          )}
  

          {!isCommentTabVisible && (
            <button 
              onClick={fetchComments}
              id = "view-comments-button">
              <h4>{translations[language].viewComments}</h4>
            </button>
          )}

          {isCommentTabVisible && (
            <button 
              onClick={() => setIsCommentTabVisible(false)}
              id = "view-comments-button">
              <h4>{translations[language].hideResponses}</h4>
            </button>
          )}

{isCommentTabVisible && (
            <div>

            {comments.length === 0 && (
                <div className="event-card">
                    <p>{translations[language].noComments}</p>
                </div>
            )}

            {!comments.length == 0 && (
                <div className="event-card">
                    <p>{translations[language].showingAllComments} </p>
                </div>
            )}

            {comments.map(comment => {
                return(
                    <CommentCard 
                        onclose={setIsCommentTabVisible}
                        comment_id = {comment.id}
                        content={comment.content} 
                        image ={comment.image}
                        video={comment.video}
                        date_created={comment.date_created} 
                        number_likes={comment.likes}
                        event_name = {comment.event}
                        author={comment.author}
                        fetchComments= {fetchComments}
                    />
                )
            })}
            </div>
        )}
        </div>
    )

}

export default SingleEventForm;